module.exports = __webpack_public_path__ + "static/media/hidden.39738cc3.png";